import Vue from 'vue';
import App from './App.vue';
// import router from './router';
import VueSVGIcon from 'vue-svgicon';
import SocialSharing from 'vue-social-sharing';
import VueLazyload from 'vue-lazyload';
import Router from 'vue-router';
import Meta from 'vue-meta';
import VueLazyLoadVideo from 'vue-lazyload-video';
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;
Vue.use (VueSVGIcon);
Vue.use (SocialSharing);
Vue.use (VueLazyload);
Vue.use (VueLazyLoadVideo);
Vue.use (Router);
Vue.use (Meta);
Vue.use (VueScrollTo);

Vue.prototype.$retina = window.devicePixelRatio > 1;

new Vue ({
  // router,
  render: h => h (App),
  mounted: () => document.dispatchEvent (new Event ('x-app-rendered')),
}).$mount ('#app');
